import React, { Component } from 'react';

import { DataTable } from 'components/dataTable';
import { ORDER_BY } from 'components/table/constants';
import { UserInfo } from 'components/user';
import { USER_TYPE } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

class ClassUsersList extends Component {
  // #region set up
  static propTypes = {
    classId: PropTypes.string,
    fetchItems: PropTypes.func,
    items: PropTypes.array,
    loading: PropTypes.bool,
    pagination: PropTypes.object,
    updateCheckItems: PropTypes.func
  };

  dataTableRef = React.createRef();

  constructor(props) {
    super(props);

    this.dataTableOpts = {
      columns: [
        {
          name: 'userName',
          label: 'general.name',
          defaultOrderBy: ORDER_BY.ASC,
          sortName: 'userName'
        },
        { name: 'userType', label: 'general.category' }
      ]
    };

    this.updateItems = this.updateItems.bind(this);
  }

  async componentDidMount() {
    this.updateItems();
  }
  // #endregion

  // #region handlers
  updateItems(page) {
    if (this.dataTableRef && this.dataTableRef.current) {
      this.dataTableRef.current.updateItems(page);
    }
  }
  // #endregion

  // #region render
  render() {
    const { items, fetchItems, loading, pagination, updateCheckItems } =
      this.props;
    const columns = this.dataTableOpts.columns;

    return (
      <DataTable
        columns={columns}
        fetchItems={fetchItems}
        items={items}
        loading={loading}
        pagination={pagination}
        ref={this.dataTableRef}
        onSelect={updateCheckItems}
      >
        <DataTable.Header>
          <DataTable.Row>
            <DataTable.SelectAll />
            <DataTable.Header.Columns />
          </DataTable.Row>
        </DataTable.Header>

        <DataTable.Body>
          {items.map((item) => (
            <DataTable.Row key={item.id}>
              <DataTable.SelectItem item={item} />

              <DataTable.DataColumns>
                <DataTable.Cell>
                  <UserInfo
                    name={item.userName}
                    email={item.userEmail}
                    pictureThumbId={item.userPictureThumbId}
                    pictureFileKey={item.pictureFileKey}
                  />
                </DataTable.Cell>

                <DataTable.Cell
                  label={USER_TYPE[item.userType]}
                  columnName={columns[1].label}
                />
              </DataTable.DataColumns>
            </DataTable.Row>
          ))}
        </DataTable.Body>

        <DataTable.Footer />
      </DataTable>
    );
  }
  // #endregion
}

export default ClassUsersList;
